module.exports = __webpack_public_path__ + "img/2.049bfae5.jpg";